
(function () {
  'use strict';
  angular.module('vctracker')
    .component('trackereditor', {
      restrict: 'E',
      bindings: {
        tracker: '<?',
        trackerid: '<?'
      },
      template: `
        <trackerform tracker="vm.tracker" parentsave="vm.childsave(tracker)" oncancel="vm.oncancel()">
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Tracker erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Editieren eines neuen Trackers wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Tracker konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Tracker', 'Rlog',
        function ($log, Tracker, Rlog) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          
          vm.$onInit = function () {
            if ((angular.isUndefined(vm.tracker) || !vm.tracker.hasOwnProperty('_id'))
              && angular.isDefined(vm.trackerid)) {
              Tracker.$find(vm.trackerid).$then(function (tracker) {
                vm.tracker = tracker;
              }, function (err) {
                $log.error('tracker not found, id: ', vm.trackerid);
                Rlog.error('tracker', 'trackereditor', 'tracker not found', {_id: vm.trackerid});
              });
            }
          };
          
          function childsave(tracker) {
            // vm.tracker = angular.copy(tracker);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in tracker) {
              if (tracker.hasOwnProperty(key)) {
                vm.tracker[key] = tracker[key];
              }
            }
            vm.save();
          }
          
          function save() {
            if (vm.tracker.$hasPendingActions()) {
              vm.tracker.$cancel();
              vm.tracker.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of tracker failed: ', err);
                Rlog.error('vcutils.tracker', 'trackereditor', 'Saving of tracker failed: ', {trackerid: vm.tracker._id});
              });
            }
            else {
              vm.tracker.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of tracker failed: ', err);
                Rlog.error('vcutils.tracker', 'trackereditor', 'Saving of tracker failed: ', {trackerid: vm.tracker._id});
              });
            }
          }
          
          function oncancel() {
            vm.canceled = true;
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());